import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { Engine, EngineListQuery } from '@rossum/api-client/engines';
import { ElisClientError } from '@rossum/api-client/errors';
import { api } from '../../../lib/apiClient';

const QUERY_KEY_ENGINES_UNPAGINATED = 'engines-unpaginated';

export const useUnpaginatedEngines = <TReturnedData = Engine[]>(
  query: EngineListQuery = {},
  queryOptions: Omit<
    UseQueryOptions<
      Engine[],
      ElisClientError,
      TReturnedData,
      [typeof QUERY_KEY_ENGINES_UNPAGINATED, EngineListQuery]
    >,
    'queryKey' | 'queryFn'
  > = {}
) =>
  useQuery({
    queryKey: [QUERY_KEY_ENGINES_UNPAGINATED, query],

    queryFn: ({ queryKey }) =>
      api.unpaginatedRequest(endpoints.engines.list)(queryKey[1]),

    ...queryOptions,
  });
